import Role from '@/api/Role'

export default {
	isAdminStaff () {
		return Role.show().then(function (response) {
			return response.data.data.is_admin_staff
		}).catch(function (response) {
			return false
		})
	},
	isNotAdminStaffHigher (roles) {
		if (roles.is_admin_staff != true && roles.is_call_center != true && roles.is_branch_office != true && roles.is_main_office != true) {
			return true
		}

		return false
	}
}



// WEBPACK FOOTER //
// ./src/services/RoleService.js